module.exports = __webpack_public_path__ + "03_very_short_black.d981cb35.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_very_short_black.png
// module id = kWAv
// module chunks = 0